import { type ReactNode } from 'react';
import { Chip } from '@zep-us/zus';
import { PreviewCardMedia } from './PreviewCardMedia';
const PreviewCardRoot = ({
  children
}: {
  children: ReactNode;
}) => <div className="flex w-[275px] flex-col gap-sm rounded-md bg-default px-xs pb-md pt-xs shadow-lg" data-sentry-component="PreviewCardRoot" data-sentry-source-file="PreviewCard.tsx">
    {children}
  </div>;
const PreviewCardHeading = ({
  children
}: {
  children: ReactNode;
}) => <div className="px-xs" data-sentry-component="PreviewCardHeading" data-sentry-source-file="PreviewCard.tsx">
    <div className="flex flex-col gap-3xs px-4xs">{children}</div>
  </div>;

/** icon 은 20px(size="sm") 로 넘긴다 */
const PreviewCardTitle = ({
  icon,
  children
}: {
  icon?: ReactNode;
  children: ReactNode;
}) => <div className="flex items-center gap-3xs" data-sentry-component="PreviewCardTitle" data-sentry-source-file="PreviewCard.tsx">
    {icon ? <span aria-hidden className="flex shrink-0">
        {icon}
      </span> : null}
    <span className="text-body-lg-semibold text-neutral">{children}</span>
  </div>;
const PreviewCardDescription = ({
  children
}: {
  children: ReactNode;
}) => <p className="text-body-md-medium text-alternative" data-sentry-component="PreviewCardDescription" data-sentry-source-file="PreviewCard.tsx">{children}</p>;
const PreviewCardTags = ({
  items
}: {
  items: readonly string[];
}) => <ul className="flex flex-wrap gap-2xs px-xs" data-sentry-component="PreviewCardTags" data-sentry-source-file="PreviewCard.tsx">
    {items.map(item => <li key={item}>
        <Chip size="md" className="text-caption-md-semibold">
          <span className="px-4xs">{item}</span>
        </Chip>
      </li>)}
  </ul>;
export const PreviewCard = Object.assign(PreviewCardRoot, {
  Media: PreviewCardMedia,
  Heading: PreviewCardHeading,
  Title: PreviewCardTitle,
  Description: PreviewCardDescription,
  Tags: PreviewCardTags
});